import React from 'react'
import { Panel } from '@components/Panel/Panel'
import { PanelButton } from '@components/Panel/PanelButton'
import { Icon, Text } from '@ui'
import { usePanelActions } from 'routes/layouts/hooks/usePanelActions'

import { NftsList } from './NftsList'
import { useGetAssetSourceParam, useIsAAWallet } from './useGetWalletParam'

export function SingleWalletPanel() {
    const isAAWallet = useIsAAWallet()
    const walletAddress = useGetAssetSourceParam()
    const { openPanel } = usePanelActions()

    const onTransferAsset = () => {
        openPanel('transfer-assets', { assetSource: walletAddress })
    }

    if (!isAAWallet) {
        return <></>
    }

    const title = isAAWallet ? 'Towns Wallet' : ''

    return (
        <Panel label={title}>
            <PanelButton cursor="pointer" onClick={onTransferAsset}>
                <Icon type="linkOutWithFrame" size="square_sm" color="gray2" />
                <Text strong>Transfer Asset</Text>
            </PanelButton>
            <NftsList walletAddress={walletAddress} />
        </Panel>
    )
}
